import { createStructuredSelector } from 'reselect';
import { getAbTests } from 'state/User/selectors';
import { getAmpUrl, getCountryCode, getHost } from 'state/Config/selectors';
import { getCurrentMarket } from 'state/Location/selectors';
import {
  getCustomRadioEnabled,
  getInternationalPlaylistRadioEnabled,
  getLiveRadioEnabled,
  getNewSearchEnabled,
  getOnDemandEnabled,
} from 'state/Features/selectors';
import {
  getIsAnonymous,
  getProfileId,
  getSessionId,
} from 'state/Session/selectors';
import { getSearchFilter, getSearchQuery } from 'state/Search/selectors';
import { getWelcome } from 'state/Stations/selectors';
import { showPlaylistSelector } from 'state/Entitlements/selectors';

export const mapStateToProps = createStructuredSelector({
  ampUrl: getAmpUrl,
  abTestGroups: getAbTests,
  internationalPlaylistRadioEnabled: getInternationalPlaylistRadioEnabled,
  showPlaylistEntitlement: showPlaylistSelector,
  country: getCountryCode,
  currentMarket: getCurrentMarket,
  customRadioEnabled: getCustomRadioEnabled,
  hidePlayer: getWelcome,
  host: getHost,
  isAnonymous: getIsAnonymous,
  liveRadioEnabled: getLiveRadioEnabled,
  newSearchEnabled: getNewSearchEnabled,
  onDemandEnabled: getOnDemandEnabled,
  profileId: getProfileId,
  searchFilter: getSearchFilter,
  searchQuery: getSearchQuery,
  sessionId: getSessionId,
});
